﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

    export class GuiDetailAktionEntsorger extends GuiDetailGeneric {

        constructor() {
            super("GuiDetailAktionEntsorger");
        }

        protected override validateClient() {
            this.log("validateClient");

            const geplant = $("#VmDetail_GeplantAm").val() as string;
            this.log(`geplant=[${geplant}]`);

            const d = new Date(geplant);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            this.log(`d >= today=[${d >= today}]`);

            return d >= today;
        }
    }
